/**
 * Resources Calendar Manager
 *
 * Business logic for the resources calendar view.
 * Handles date navigation, event filtering, and view state.
 *
 * Follows manager pattern: separates business logic from UI.
 */

import { LocalDateFormatter } from '@/lib/formatters/LocalDateFormatter';

export class ResourcesCalendarManager {
  /**
   * Navigate to previous day
   */
  static getPreviousDay(currentDate: Date): Date {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() - 1);
    return newDate;
  }

  /**
   * Navigate to next day
   */
  static getNextDay(currentDate: Date): Date {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + 1);
    return newDate;
  }

  /**
   * Get today's date at midnight
   */
  static getToday(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  /**
   * Format date for header display
   * Example: "Thursday, Dec 5, 2025"
   */
  static formatHeaderDate(date: Date): string {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  }

  /**
   * Convert Date to YYYY-MM-DD string
   */
  static toDateKey(date: Date): string {
    return LocalDateFormatter.toDateKey(date);
  }

  /**
   * Parse YYYY-MM-DD to Date
   */
  static fromDateKey(dateKey: string): Date {
    return LocalDateFormatter.fromDateKey(dateKey);
  }

  /**
   * Check if two dates are the same day
   */
  static isSameDay(date1: Date, date2: Date): boolean {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
}
